import React, { useState, useEffect, useRef } from 'react';
import styled from "styled-components";
import ModalPortal from "util/component/Modal";
import { Confirm } from "util/component/Modal/Modal";
import { useTranslation } from 'react-i18next';

export const HeaderWrap = styled.header`
    width:100%;  
`

export const NavTop = styled.nav`
    .navWrap {
        width: 100%; 
        height: 26px; 
        background-color: rgb(241, 241, 241);
        z-index: 1000;
        ul {
            display: flex; 
            justify-content: right;
            gap: 15px;
            align-items: center;
            margin-right: 15px;
            height: 100%;
            & * {
                display: flex;
                justify-content: center;
                align-items: center;
            }
            & .lang {
                & button {
                    margin: 0 3px;
                    cursor: pointer;
                }
                & .on {
                    text-decoration: underline;
                }
            }
            & button {
                border: none;
                
            }
            & svg {
                font-size: 20px;
            }
        }
    }
    
    
`
export const GnbWrap = styled.div`
    display: flex; 
    height: 50px; 
    border-bottom: 
    1px solid #ddd;
    width: 100%; 
    justify-content: stretch; 
    align-items: center;
    .logo {
        flex: 0 0 auto;
        margin-left: 20px;
    }
    .title {
        flex: 0 0 auto;
        align-self: end;
        margin-left: 10px;
        margin-bottom: 3px;
        font-size: 20px;
        font-weight: bold;
    }
    ul.menu {
        flex: 1 0 auto;
        display: flex; 
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
        >li { 
            flex: 0 0 150px; 
            text-align: center;
            cursor: pointer;
            &:hover {
                color: #5679ff;
            }
            a, p {
                font-weight: bold; 
                font-size: 18px;
                width: 100%;
                display: block;
                color: inherit
            }
            &.has-child {
                position: relative;
                &:hover {
                    div.sub-menu {
                        transform: scaleY(1);
                    }
                }
                div.sub-menu {
                    transition: .2s all ease;
                    transform-origin: top;
                    position: absolute;
                    top: calc(100% + 10px);
                    left: 0;
                    width: 100%;
                    transform: scaleY(0);
                    overflow: hidden;
                    background-color: var(--bg-white);
                    z-index: 50;
                    border-radius: 10px;
                    border: 1px solid #EEE;
                    box-shadow: 0px 2px 8px 1px #AAA;
                    li {
                        text-align: left;
                        
                        position: relative;
                        a {
                            color: var(--font-gray1);
                            padding: 10px 10px 10px 30px;
                            display: block;
                        }
                        &::before {
                            content: ">";
                            position: absolute;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 30px;
                            height: 100%;
                            top: 0;
                            left: 0px;
                            color: var(--font-gray1);
                        }
                        &:hover {
                            background-color: var(--main-light-color)
                        }
                    }
                }
            }
        }

    }
    

`
export const Icons = styled.div`
    ul { display: flex; just-content: right;
        li {
            margin: 0 10px; font-size: 23px;
        }
    }
`

export const Logo = styled.div`
    display: flex;
    font-family: 'Arial Black';
    line-height: 1;
    font-size: 38px;
    letter-spacing: 3px;
`

export const TitleSelect = styled.div`
    &.on {
        ul {
            max-height: 120px;
            opacity: 1;
        }
    }
    ul {
        max-height: 0;
        background-color: #FFFFFF;
        position: absolute; 
        top: calc(100% + 3px);
        left: 0;
        width: max-content;
        color: #666;
        list-style-type: none;
        padding: 0;
        border-radius: 6px;
        overflow: hidden;
        opacity: 0;
        transition: .05s ease-in;
        box-shadow: 0px 5px 8px 1px #AAA;
        z-index: 10000;
        li {
            &[disabled] {
                color: #AAAAAA;
            }
            padding: 8px 12px;
            cursor: pointer;
            font-size: 18px;
            :not(:last-of-type) {
                border-bottom: 1px solid #CCC;
            }
            
            :not([disabled]):hover {
                background-color: rgba(164, 152, 255, 0.2);
            }
        }
    }
    p {
        margin-right: 10px;
    }
    font-size: 23px;
    font-weight: bold;
    position: relative;
    min-width: 100px;
    height: 30px;
    padding: 3px 20px 3px 3px;
    cursor: pointer;
    ::after {
        content: '';
        width: 14px;
        height: 80%;
        background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" fill="rgba(75,75,75,1.0)" viewBox="0 0 448 512"><path  d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/></svg>') center no-repeat;
        position: absolute;
        top: 20%;
        right: 3px;
    }
    
`
export const TitleSelectDiv = (props) => {
    const [Show, SetShow] = useState(false);
    const selectRef = useRef(null);
    const [ModalShow, SetModalShow] = useState(null);

    const goPage = (e) => {
        if (e.target.getAttribute("disabled") == null) {
            window.location.href = "https://bplsmp.sbiologics.com";
        }
    }
    const onConfirm = () => {
        SetModalShow(null);
    }

    useEffect(() => {
        const showFunction = (e) => {
            if(e.target.getAttribute("disabled") != null) {
                return;
            }
            if (e.target.closest(".select") === selectRef.current) {
                SetShow(!Show);
            } else {
                if (selectRef.current?.classList.contains("on")) {
                    SetShow(false);
                }
            }
        }
        document.addEventListener("click", showFunction);
        return () => {
            document.removeEventListener("click", showFunction);
        }
    }, [Show, SetShow])

    return <><TitleSelect ref={selectRef} className={`select ${Show ? "on" : ""}`}>
        <p>Process</p>
        <ul>
            <li onClick={goPage} disabled>Process</li>
            <li onClick={goPage}>Sample</li>
            {/*<li onClick={goPage}>Operation</li>*/}
        </ul>
    </TitleSelect>
        {ModalShow && <ModalPortal>
            <Confirm
                onClose={() => SetModalShow(null)}
                valid={() => { return true }}
                onConfirm={onConfirm}
                autoComplete={false}
            >Move the site : <br /><p className="text-center">[{ModalShow}]</p></Confirm>
        </ModalPortal>}
    </>
}